import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["container", "controls"]

  // TODO: must be reviewed: why not assign it in `initialize` hook?
  currentPage = 0

  connect() {
    this.resize()
    this.lastPage = Math.ceil(this.containerTarget.scrollWidth / this.width) - 1
    if (document.getElementsByClassName("login").length > 0) {
      this.timer = this.autoplay()
    }
  }

  autoplay() {
    return window.setInterval(() => window.setTimeout(() => {
      this.page++
    }, 4000), 4000)
  }

  resize() {
    this.width = this.containerTarget.offsetWidth
  }

  get page() {
    return this.currentPage
  }

  set page(value) {
    if (value < 0) value = this.lastPage
    if (value > this.lastPage) value = 0

    if (Math.abs(this.currentPage - value) === 1) {
      this.controlsTarget.querySelector(`[data-page="${this.currentPage}"`)?.classList.remove("active")
      this.controlsTarget.querySelector(`[data-page="${value}"`)?.classList.add("active")
      this.containerTarget.scrollLeft = value * this.width
    } else {
      this.controlsTarget.querySelector(`[data-page="${this.currentPage}"`)?.classList.remove("active")
      this.containerTarget.style.scrollBehavior = "auto"
      this.containerTarget.scrollLeft = value * this.width
      this.containerTarget.style.scrollBehavior = "smooth"
      this.controlsTarget.querySelector(`[data-page="${value}"`)?.classList.add("active")
    }
    this.currentPage = value
  }

  prev(event) {
    event.preventDefault()
    this.page--
  }

  next(event) {
    event.preventDefault()
    this.page++
  }

  goto(event) {
    event.preventDefault()
    const page = event.currentTarget.dataset.page
    this.page = page
  }
}
